// EXACT COPY of app/Support/OrganTaxonomy.php::LABELS + ::SORT_ORDER.
// Source of truth — backend (`OrganSummary.organ_label_ru`). Этот файл —
// defensive fallback + sort для случаев без backend label. При изменении backend
// констант — обновить здесь + sync-тест (organ-taxonomy.sync.test.ts) упадёт.
//
// CANONICAL/EXCLUDED (нормализация сырых RU-тегов) — backend-only, фронт сырых
// тегов не видит, поэтому НЕ зеркалятся (как у category-labels.ts).
//
// Source of truth: docs/specs/sprint-6-organs/stage-1-contracts.md §5/§6.

export const ORGAN_LABELS_RU: Record<string, string> = {
  female_reproductive: 'Женская репродуктивная система',
  ovaries: 'Яичники',
  uterus: 'Матка',
  mammary_glands: 'Молочные железы',
  male_reproductive: 'Мужская репродуктивная система',
  testes: 'Яички',
  prostate: 'Предстательная железа',
  bone_marrow: 'Костный мозг',
  hematopoietic: 'Кроветворная система',
  blood: 'Кровь',
  spleen: 'Селезёнка',
  lymphatic: 'Лимфатическая система',
  endocrine: 'Эндокринная система',
  thyroid: 'Щитовидная железа',
  adrenals: 'Надпочечники',
  parathyroid: 'Паращитовидные железы',
  pituitary: 'Гипофиз',
  pancreas: 'Поджелудочная железа',
  kidneys: 'Почки',
  liver: 'Печень',
  large_intestine: 'Толстый кишечник',
  small_intestine: 'Тонкий кишечник',
  stomach: 'Желудок',
  gallbladder: 'Желчный пузырь',
  vessels: 'Сосуды',
  heart: 'Сердце',
  lungs: 'Лёгкие',
  nervous_system: 'Нервная система',
  skin: 'Кожа',
  hair_nails: 'Волосы и ногти',
  bones: 'Костная система',
  joints: 'Суставы',
  muscles: 'Мышцы',
  connective_tissue: 'Соединительная ткань',
  musculoskeletal: 'Опорно-двигательная система',
  immune: 'Иммунная система',
  metabolism: 'Обмен веществ',
  urinary_tract: 'Мочевой пузырь и мочевыводящие пути',
  urethra: 'Мочеиспускательный канал',
  vagina: 'Влагалище',
  cervix: 'Шейка матки',
  intestine: 'Кишечник',
  eyes: 'Глаза',
};

// Identity-фаза: явного порядка нет (backend добивает markers_total desc + code).
export const ORGAN_SORT_ORDER: Record<string, number> = {};

/** RU label по canonical-коду; fallback на код (как backend OrganTaxonomy::label). */
export function organLabelFor(code: string): string {
  return ORGAN_LABELS_RU[code] ?? code;
}
